module.exports = __webpack_public_path__ + "static/img/stkLogo2.bce736a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stkLogo2.png
// module id = i0xP
// module chunks = 1